<!-- eslint-disable -->

<template>
  <div class="container container--large">
    <!-- selected names dialog -->
    <md-dialog :md-active.sync="showDialogName">
      <!-- <md-dialog-title>Preferences</md-dialog-title> -->
      <md-content>
        <div id="promotions" class="popup">
          <div class="popup__head">
            <h5>Selected Names : {{ selNames.length }}</h5>

            <a
              @click="showDialogName = false"
              class="popup-modal-dismiss btn-close"
            >
              <i class="ico-close"></i>
            </a>
          </div>
          <!-- /.popup__head -->

          <div class="popup__content popup-names">
            <div
              v-for="item in selNames"
              :key="item.id"
              class="promo-wrap-wide"
            >
              {{ item.title }} {{ item.lastName }} {{ item.firstName }}
              {{ item.sFirstName }}
            </div>
            <!-- /.list-checks -->
          </div>
          <!-- /.popup__content -->
        </div>
      </md-content>

      <md-dialog-actions style="border-top: 1px solid #f0f0f0">
        <md-button class="md-primary btn-grey" @click="showDialogName = false"
          >Close</md-button
        >
      </md-dialog-actions>
    </md-dialog>

    <section class="section-web">
      <div class="row" v-if="!isMobile">
        <div class="col-md-10 offset-md-1">
          <p class="last-year-p">
            <strong>Last Year's Order History Page: </strong>
          </p>
          <p class="l-y-sub">
            This page shows the people you sent to, received from, and/or
            reciprocated to last year
          </p>
          <p class="last-year-p r-wrap">
            <span class="review">PLEASE REVIEW CAREFULLY </span>
            <span class="review-1">
              For your convenience, they have all been added to your shopping
              cart. You can easily remove any or all names by un-checking the
              boxes below.</span
            >
          </p>
        </div>
        <div class="col-xs-12 col-sm-12">
          <p style="text-align: left; font-weight: 600">
            *Please be aware that names on your order history may be part of
            package deals
          </p>
        </div>
        <!-- /.filters -->

        <!-- /.section__note -->
      </div>
      <!-- /.section__actions -->

      <div class="section__content">
        <div class="boxes">
          <div
            class="boxes__head d-lg-flex justify-content-between align-items-center d-none"
          >
            <div class="boxes__checkbox d-flex align-items-center">
              <div class="custom-control-check">
                <md-checkbox
                  v-model="checkAll"
                  class="md-primary cust-check"
                  @change="checkAllPpl()"
                  >Check/Uncheck All</md-checkbox
                >
              </div>

              <div
                class="boxes__foot d-flex align-items-center flex-wrap"
                v-if="settings[0].displayLastYearsOrders && !isMobile"
              >
                <p>People I</p>

                <ul class="list-notes">
                  <li>
                    <span class="green"></span>

                    <p>Sent</p>
                  </li>

                  <li>
                    <span class="yellow"></span>

                    <p>Reciprocated</p>
                  </li>

                  <li>
                    <span class="blue"></span>

                    <p>Received</p>
                  </li>
                </ul>
                <!-- /.list-notes -->
              </div>
            </div>
            <!-- /.boxes__checkbox -->

            <div class="boxes__aside d-flex align-items-center">
              <div class="section__note d-flex align-items-center">
                <span>{{ selNumber.length }}</span>

                <p>
                  <a
                    @click="openSelectedNames(filteredData)"
                    class="name-a"
                    style="color: #3359d7 !important"
                    title="View Selected Names"
                    >Names Selected</a
                  >
                </p>
                <!-- <i class="fad fa-eye"></i> -->
              </div>

              <!-- /.search -->
            </div>
            <!-- /.boxes__aside -->
          </div>
          <!-- /.boxes__head -->
          <!-- MOBILE CATEGORIES -->

          <!-- /.boxes__outer -->

          <div class="boxes__outer d-block d-lg-none filters mobile-wrap">
            <div class="row">
              <div class="col-md-10 offset-md-1">
                <p class="last-year-p">
                  <strong>Last Year's Order History Page: </strong>
                </p>
                <p class="l-y-sub">
                  This page shows the people you sent to, received from, and/or
                  reciprocated to last year
                </p>
                <p class="last-year-p r-wrap">
                  <span class="review">PLEASE REVIEW CAREFULLY </span>
                  <span class="review-1">
                    For your convenience, they have all been added to your
                    shopping cart. You can easily remove any or all names by
                    un-checking the boxes below.</span
                  >
                </p>
              </div>
              <div class="col-xs-12 col-sm-12">
                <p style="text-align: left; font-weight: 600">
                  *Please be aware that names on your order history may be part
                  of package deals
                </p>
              </div>
              <!-- /.filters -->

              <!-- /.section__note -->
            </div>
            <div class="mobile-controll">
              <div class="filters">
                <md-checkbox
                  v-model="checkAll"
                  class="md-primary cust-check"
                  @change="checkAllPpl()"
                  >Check/Uncheck All</md-checkbox
                >
                <!-- /.filter -->
              </div>
              <!-- /.filters -->

              <!-- /.search -->

              <div
                class="boxes__note align-items-center"
                style="text-align: center"
              >
                <span>{{ selNumber.length }}</span>
                <p style="text-align: left">
                  <a
                    @click="openSelectedNames(filteredData)"
                    style="color: #3359d7 !important"
                    title="View Selected Names"
                    >Names <br />Selected</a
                  >
                </p>
              </div>
            </div>
            <!-- /.boxes__head -->
          </div>
          <!-- /.boxes__outer -->
          <!-- MOBILE -->

          <!-- /.boxes__actions -->

          <div class="boxes__content">
            <div
              class="boxes__foot d-flex align-items-center flex-wrap"
              v-if="settings[0].displayLastYearsOrders && isMobile"
            >
              <p>People I</p>

              <ul class="list-notes">
                <li>
                  <span class="green"></span>

                  <p>Sent</p>
                </li>

                <li>
                  <span class="yellow"></span>

                  <p>Reciprocated</p>
                </li>

                <li>
                  <span class="blue"></span>

                  <p>Received</p>
                </li>
              </ul>
              <!-- /.list-notes -->
            </div>
            <div class="row">
              <div
                class="col-lg-3 mb-2"
                v-for="item in filteredData"
                :key="item.id"
                v-bind:class="{ 'custom-mb2': organizationInfo.id == 647 }"
              >
                <!-- v-bind:class="{'custom-checkbox--green':item.iSentLastYear && item.reciprocal !== 'Yes','custom-checkbox--blue':item.sentToMeLastYear && item.reciprocal !== 'Yes', 'custom-checkbox--yellow':item.reciprocal === 'Yes'  }" -->

                <div
                  class="custom-control custom-checkbox custom-checkbox--large list"
                  v-bind:class="{
                    'custom-checkbox--green':
                      (item.iSentLastYear && item.reciprocal !== 'Yes') ||
                      (item.sentToMeLastYear &&
                        item.iSentLastYear &&
                        item.reciprocal !== 'Yes'),
                    'custom-checkbox--blue':
                      item.sentToMeLastYear &&
                      item.reciprocal !== 'Yes' &&
                      !item.iSentLastYear,
                    'custom-checkbox--yellow': item.reciprocal === 'Yes',
                    'custom-column': item.basketType,
                  }"
                >
                  <input
                    type="checkbox"
                    v-model="item.selected"
                    class="md-primary md-custom-paid"
                    :disabled="item.paid"
                    v-bind:id="item.id"
                  />
                  <label
                    v-bind:for="item.id"
                    class="checkbox-label"
                    v-if="
                      custom.displayTitles.indexOf(
                        settings[0].organizationId
                      ) === -1
                    "
                    >{{ item.lastName }} {{ item.firstName }}
                    <span v-if="item.sFirstName !== ''">&</span>
                    {{ item.sLastName }} {{ item.sFirstName }}
                    <span
                      v-if="
                        showPrices &&
                          item.price > 0 &&
                          organizationInfo.id !== 647
                      "
                      >{{ item.price | currency }}</span
                    ></label
                  >
                  <label
                    v-bind:for="item.id"
                    class="checkbox-label"
                    v-if="
                      custom.displayTitles.indexOf(settings[0].organizationId) >
                        -1 && item.sFirstName
                    "
                    >{{ item.lastName }} {{ item.firstName }}
                    <span v-if="item.title !== ''">{{ item.title }}</span>
                    {{ item.sLastName }} {{ item.sFirstName }}
                    <span
                      v-if="
                        showPrices &&
                          item.price > 0 &&
                          organizationInfo.id !== 647
                      "
                      >{{ item.price | currency }}</span
                    ></label
                  >
                  <label
                    v-bind:for="item.id"
                    class="checkbox-label"
                    v-if="
                      custom.displayTitles.indexOf(settings[0].organizationId) >
                        -1 && !item.sFirstName
                    "
                  >
                    <span v-if="item.title !== ''">{{ item.title }}</span>
                    {{ item.lastName }} {{ item.firstName }}
                    <span
                      v-if="
                        showPrices &&
                          item.price > 0 &&
                          organizationInfo.id !== 647
                      "
                      >{{ item.price | currency }}</span
                    >
                  </label>

                  <br />
                  <!-- <p>I sent: {{item.iSentLastYear}}// I received: {{item.sentToMeLastYear}}</p> -->
                  <span class="sub-label" v-if="settings[0].displayMisc2">{{
                    item.category
                  }}</span>

                  <span
                    class="btn-wrap"
                    style="display: block; width: 100%"
                    v-if="organizationInfo.id == 647"
                  >
                    <md-button
                      class="btn-blue"
                      @click="
                        item.basketType = 'Regular Baskets';
                        item.selected = false;
                        item.selected = true;
                      "
                      v-bind:class="{
                        'btn-grey': item.basketType !== 'Regular Baskets',
                      }"
                      style="
                        color: white;
                        min-width: 80px !important;
                        height: 25px;
                        font-size: 12px;
                        min-height: 25px;
                      "
                      >Regular</md-button
                    >
                    <md-button
                      class="btn-blue"
                      @click="
                        item.basketType = 'Premium Baskets';
                        item.selected = false;
                        item.selected = true;
                      "
                      v-bind:class="{
                        'btn-grey': item.basketType !== 'Premium Baskets',
                      }"
                      style="
                        color: white;
                        min-width: 80px !important;
                        height: 25px;
                        font-size: 12px;
                        min-height: 25px;
                      "
                      >Premium</md-button
                    >
                  </span>
                </div>
              </div>
              <!-- /.col-md-3 -->
            </div>
            <!-- /.row -->
          </div>
          <!-- /.boxes__content -->

          <!-- /.boxes__notes -->

          <div
            class="boxes__actions boxes__actions--mobile d-flex justify-content-lg-end justify-content-center flex-wrap"
          >
            <!-- <ul class="list-buttons list-buttons--mobile">
              <li>
                <md-button @click="restoreList()" class="btn-grey"
                  >Undo Changes</md-button
                >
              </li>

              <li>
                <md-button
                  @click="saveList(filteredData, promotions)"
                  class="btn-blue"
                  >Save for later</md-button
                >
              </li>
            </ul> -->
            <!-- /.list-buttons -->
            <md-button class="btn-green" @click="next()"
              >Proceed To General Ordering</md-button
            >
          </div>
          <!-- /.boxes__actions -->
        </div>
        <!-- /.boxes -->
      </div>
      <!-- /.section__content -->
    </section>
    <!-- /.section-web -->
  </div>
  <!-- /.container container-/-large -->
</template>
<script>
import currencyFilter from "../shared/currency-filter";

export default {
  name: "OrderHistoryPage",
  filters: {
    currency: currencyFilter,
  },
  data: function() {
    return {
      hidePaid: false,
      list: [],
      listCopy: [],
      search: "",
      showDialog: false,
      showPromotionsMobile: false,
      selFilter: 4,
      filterOptions: [
        { Label: "All", value: 4 },
        { Label: "People I sent to Last Year", value: 1 },
        { Label: "People I reciprocated to Last year", value: 2 },
        { Label: "People I received from Last Year", value: 3 },
      ],
      selCategory: 1,

      checkAll: false,
      reciprocity: false,
      sortOrder: false,
      sortOptions: [
        { Label: "A-Z", value: false },
        { Label: "Z-A", value: true },
      ],
      showDialogName: false,
      selNames: [],
    };
  },
  watch: {
    selNumber: function(val) {
      //consoleg("val ", val);
      if (!val.length) {
        this.reciprocity = false;
        this.$store.state.cart.reciprocity = false;
      }
    },
  },
  computed: {
    customOptions() {
      return this.$store.state.customOptions;
    },
    showPrices() {
      return this.$store.state.showPrices;
    },
    custom() {
      return this.$store.state.custom[0];
    },

    isMobile() {
      return this.$store.getters.isMobile;
    },
    settings() {
      return this.$store.state.settings;
    },
    organizationInfo() {
      return this.$store.state.organizationInfo[0];
    },
    reciprocity2: {
      // //consoleg("this.$store.state.cart.reciprocity",this.$store.state.cart.reciprocity)

      get() {
        return this.$store.state.cart.reciprocity;
      },
      set(newName) {
        return newName;
      },
    },
    selNumber() {
      let obj = this.filteredData;
      let n = obj.filter((a) => a.selected && !a.paid);
      //consoleg("n ", n);
      return n;
    },
    selNumberPaid() {
      let obj = this.$store.state.list;
      let n = obj.filter((a) => a.selected && a.paid);

      return n;
    },

    categories() {
      //consoleg("this.$store.state.categories", this.$store.state.categories);
      return this.$store.state.categories;
    },
    promotions() {
      return this.$store.state.promotions;
    },

    filteredData() {
      let obj = this.$store.state.list;
      let prop = "Name";

      //   if (Number(this.selCategory) !== 1) {
      //     obj = obj.filter((data) => data.mCategories.indexOf(Number(this.selCategory)) !== -1);
      //   }

      let obj1 = obj.filter(
        (data) =>
          data.iSentLastYear === 1 &&
          data.reciprocal !== "Yes" &&
          data.sentToMeLastYear === 0
      );
      let obj2 = obj.filter(
        (data) => data.sentToMeLastYear === 1 && data.reciprocal !== "Yes"
      );
      let obj3 = obj.filter((data) => data.reciprocal === "Yes");
      obj = obj1.concat(obj2, obj3);
      // for (let i = 0; i < obj.length; i++) {
      //   obj[i].selected = true;
      // }

      if (!this.sortOrder) {
        obj = obj.sort(function(a, b) {
          return a[prop] > b[prop] ? 1 : b[prop] > a[prop] ? -1 : 0;
        });
      } else {
        obj = obj.sort(function(a, b) {
          return a[prop] > b[prop] ? 1 : b[prop] > a[prop] ? 0 : -1;
        });
      }
      console.log("filtered data ", obj);
      return obj;
    },
  },
  methods: {
    next: function() {
      this.saveList(this.filteredData, this.promotions).then();
    },
    updateStoreList: function(data) {
      // let obj = this.$store.state.cart.list.filter(
      //   (d) => d.id === data.id
      // );
      //consoleg("updaaating", data, obj);
    },
    openSelectedNames: function(d) {
      let data = this.$store.state.list;
      this.showDialogName = true;
      this.selNames = [];
      if (data.length) {
        for (let i = 0; i < data.length; i++) {
          if (data[i].selected && !data[i].paid) {
            this.selNames.push(data[i]);
          }
        }
      }
    },
    selRecip: function(val) {
      this.$store.commit("updateReciprocity", val);
    },
    checkAllPpl: function() {
      if (this.checkAll === false) {
        for (let i = 0; i < this.filteredData.length; i++) {
          if (!this.filteredData[i].paid) {
            this.filteredData[i].selected = false;
          }
        }
      } else {
        for (let i = 0; i < this.filteredData.length; i++) {
          if (!this.filteredData[i].paid) {
            this.filteredData[i].selected = true;
          }
        }
      }
      let data = [];
      for (let i = 0; i < this.filteredData.length; i++) {
        if (!this.filteredData[i].paid && this.filteredData[i].selected) {
          data.push(this.filteredData[i]);
        }
      }
    },
    async savePromotions(promo) {
      try {
        let parsedpromo = JSON.parse(JSON.stringify(promo));
        for (let i = 0; i < parsedpromo.length; i++) {
          let obj = {
            itemId: parsedpromo[i].itemId,
            price: parsedpromo[i].price,
            quantity: 1,
            description: parsedpromo[i].displayText,
            shipTo: "",
            message: "",
          };

          if (parsedpromo[i].allCategories.length && parsedpromo[i].value) {
            for (let z = 0; z < parsedpromo[i].allCategories.length; z++) {
              if (
                parsedpromo[i].allCategories[z].toLowerCase() === "all" &&
                parsedpromo[i].value
              ) {
                for (let d = 0; d < this.filteredData.length; d++) {
                  if (!this.filteredData[d].paid) {
                    this.filteredData[d].selected = true;
                  }
                }
              } else {
                for (let k = 0; k < this.filteredData.length; k++) {
                  if (
                    !this.filteredData[k].paid &&
                    this.filteredData[k].mCategories.indexOf(
                      Number(parsedpromo[i].allCategories[z])
                    ) !== -1
                  ) {
                    this.filteredData[k].selected = true;
                  }
                }
              }
            }
          }
          // if send to all option selected

          if (parsedpromo[i].value) {
            await this.$store.dispatch("updateUpsell", {
              data: obj,
              param: "add",
            });
          } else {
            await this.$store.dispatch("updateUpsell", {
              data: obj,
              param: "delete",
            });
          }
        }
      } catch (error) {
        console.error(error);
        showErrorAlert(true);
      }
    },
    async saveList(list, promo) {
      //this.savePromotions(promo);
      let checked_arr = [];
      let unchecked_arr = [];

      let parsedlist = JSON.parse(JSON.stringify(list));
      let checked_list = parsedlist.filter((a) => a.selected && !a.paid);
      let unchecked_list = parsedlist.filter((a) => !a.selected && !a.paid);
      this.$store.commit("addListToCart", checked_list);

      for (let i = 0; i < checked_list.length; i++) {
        let item = {};
        item.tempcode = this.$store.state.tempCode;
        item.receiver = checked_list[i].id;
        if (
          !this.$store.state.shippingCustomOptions.length ||
          this.customOptions.noShipCustom.indexOf(this.organizationInfo.id) > -1
        ) {
          item.price = checked_list[i].price;
        } else {
          let ship = this.$store.state.shippingCustomOptions.filter(
            (a) => a.description === checked_list[i].basketType
          );
          item.price = ship[0].price;
          item.customPrice = ship[0].price;
        }
        checked_arr.push(item);
      }
      for (let i = 0; i < unchecked_list.length; i++) {
        let item = {};
        item.tempCode = this.$store.state.tempcode;
        item.receiver = unchecked_list[i].id;
        item.price = unchecked_list[i].price;
        unchecked_arr.push(item);
      }

      if (checked_arr.length) {
        await this.$store.dispatch("updateData", {
          data: checked_arr,
          param: "add",
        });
        this.$store.state.checked_arr = checked_arr;
      }
      if (!checked_arr.length) {
        await this.$store.dispatch("updateData", { data: [], param: "clear" });
      }
      if (!this.settings[0].displayPromotionsScreen) {
        this.$router.push("/content/list").catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      } else {
        this.$router.push("/content/promotionscreen").catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      }
    },
    onCategoryChange: function(value) {
      //consoleg("selCategory :", value, this.categories);
      // if(Number(value) === 1){
      //  this.$store.dispatch("getData",null);
      //  //consoleg ("buuuuuuuuuuuuuuuuuuuuuuug")
      // }
      // else{
      //  this.$store.dispatch("getData", value);
      // }
    },
    sortData: function(data, prop, desc) {},
    restoreList: function() {
      let copyData = localStorage.getItem("data");
      let d = JSON.parse(copyData);
      //consoleg("d", d, this.filteredData);
      for (let i = 0; i < d.length; i++) {
        for (let j = 0; j < this.filteredData.length; j++) {
          if (d[i].id === this.filteredData[j].id) {
            this.filteredData[j].selected = d[i].selected;
          }
        }
      }
    },
  },
  created() {
    //consoleg("created");
    window.scrollTo(0, 0);
    for (let i = 0; i < this.filteredData.length; i++) {
      this.filteredData[i].selected = true;
    }
  },
  mounted() {
    // this.getList();
    //consoleg("mounted");
    this.list = this.$store.state.list;
    this.listCopy = this.list;
    //consoleg("this.$store.appCode", this.$store.state.appCode);
    this.reciprocity = this.$store.state.cart.reciprocity;
  },
  updated() {
    // this.getList();
    //consoleg("mountedupdated");
    this.list = this.$store.state.list;
    this.listCopy = this.list;
  },
};
</script>
<style scoped>
.mb-2 {
  height: 55px;
  text-align: left;
}
.md-checkbox {
  /* width: 25px; */
  margin: 0;
}
.custom-checkbox--large {
  padding: 6px 5px 6px 15px;
}
.custom-control-check {
  position: relative;
  display: block;
  min-height: 1.5rem;
  padding-left: 0;
  min-width: 240px;
  text-align: left;
}
.md-checkbox .md-checkbox-label {
  height: 20px;
  padding-left: 16px;
  position: relative;
  line-height: 17px;
  min-width: 200px;
}
.checkbox-label {
  height: 20px;
  padding-left: 30px;
  position: relative;
  line-height: 17px;
  min-width: 200px;
  margin-bottom: 0;
}
.sub-label {
  font-size: 12px;
  color: grey;
  font-weight: 300;
}
.cust-check {
  width: 100%;
}
.search .search__btn {
  background-color: #ff607f;
  border-radius: 2px;
  padding: 4px 10px 3px;
  border: 0;
  /* min-height: 21px; */
  display: inline-block;
  border: 1px solid #ff607f;
}
.list-checks li + li {
  padding-left: 52px;
  margin-left: 52px;
  border-left: 0;
}
.promo-wrap {
  display: inline-block;
  width: 50%;
  padding: 0.5em;
}
.btn-green,
.btn-blue,
.btn-grey {
  text-transform: capitalize !important;
  min-width: 135px !important;
  min-height: 36px;
  padding: 0 8px !important;
}
.fa-question-circle {
  padding-left: 0.5em;
  font-size: 18px;
}
.custom-column {
  flex-direction: initial;
}
.custom-mb2 {
  min-height: 70px !important;
}
.custom-mb2 .custom-checkbox--large {
  padding: 8px 5px 6px 15px;
}
.md-button:visited {
  color: white !important ;
}
.md-button:focus {
  color: white !important ;
}
.md-ripple {
  color: white !important;
}
.section-web .section__note p {
  text-align: left;
}
.popup-names {
  overflow: auto;
  max-height: 400px;
  padding: 0.5em 2em !important;
}
.promo-wrap-wide {
  display: inline-block;
  width: 100%;
  padding: 0.5em;
}
.popup .popup__head {
  font-weight: 500;
}
.name-a {
  display: inline-block;
  vertical-align: middle;
  font-size: 17px;
  line-height: 1.06;
  letter-spacing: -0.01em;
  color: #3359d7;
  text-transform: uppercase;
  max-width: 80px;
  margin-bottom: 0;
}

@media (min-width: 1200px) {
  .col-xl-6 {
    flex: 0 0 70%;
    max-width: 70%;
  }
}
.list-checks-mobile li {
  text-align: left;
  padding: 1em;
}
.btn-grey-small {
  background-color: #c4c4c4;
  box-shadow: 2px 2px 5px 0px #c4c4c4;
  color: white !important;
  min-width: auto;
  height: 25px;
  margin: 6px 8px;
  padding: 0 1em;
  font-size: 13px;
}
.btn-blue-small {
  background-color: #5ea6f1;
  box-shadow: 2px 2px 5px 0px #5ea6f1;
  color: white !important;
  min-width: auto;
  height: 25px;
  margin: 6px 8px;
  padding: 0 1em;
  font-size: 13px;
}
.btn-green-small {
  background-color: #4bbe56;
  box-shadow: 2px 2px 5px 0px #5ef16b;
  color: white !important;
  min-width: auto;
  height: 25px;
  margin: 6px 8px;
  padding: 0 1em;
  font-size: 13px;
}
.list-tags li {
  width: auto;
}
.list-tags {
  border-bottom: 1px solid #ededed;
  padding-bottom: 1em;
}
.custom-checkbox--large {
  display: inline-block;
}
@media (max-width: 991px) {
  .boxes .boxes__actions--mobile {
    z-index: 10;
  }
}
.popup-names {
  max-height: 500px !important;
}
@media (max-width: 767px) {
  .list-buttons--mobile li {
    width: auto;
    display: inline-block;
  }
}

/* Hide the browser's default checkbox */
.list input {
  position: absolute;
  opacity: 1;
  cursor: pointer;
  height: 20px;
  width: 20px;
}

.select:before {
  z-index: 5;
  right: 11px;
}
.select select {
  z-index: 4;
  background-color: transparent;
}
.select:after {
  z-index: 3;
}
.md-field.md-clearable .md-input {
  padding-right: 30px;
  font-size: 14px;
  letter-spacing: -0.01em;
  color: #b5b4b4;
  font-weight: 400;
  background-color: #fff;
  border: 1px solid #dedede;
  border-radius: 2px;
  padding: 4px 17px 3px;
  height: 28px;
}
.md-field:after,
.md-field:before {
  display: none;
}
.md-field {
  width: 100%;
  min-height: 28px;
  margin: 0;
  padding-top: 0;
  display: flex;
  position: relative;
  font-family: inherit;
}
.md-field .md-input-action {
  top: 0 !important;
  right: 4px;
  width: 20px;
  min-width: 20px;
}
.last-year-p {
  text-align: left;
  color: #777777;
  font-size: 17px;
  margin-top: 15px;
  margin-bottom: 0;
}
.container--large {
  min-height: 800px;
}
.filters {
  padding-left: 22px;
  padding-top: 1em;
}
.last-year-p strong {
  font-size: 24px;
  color: #004eff;
}
.l-y-sub {
  text-align: left;
  font-size: 15px;
  font-weight: 600;
  color: #989898;
}
.r-wrap {
  padding: 1em;
  border: 1px solid red;
  margin-bottom: 3em;
}
.section-web .section__actions {
  padding-bottom: 0;
}
.review,
.review-1 {
  font-weight: 600;
  display: block;
  font-size: 13px;
}
.review {
  color: red;
  font-size: 15px;
}
.review-1 {
  color: #989898;
}
.mobile-wrap .last-year-p strong {
  font-size: 21px !important;
}
.mobile-wrap .m-b-0 {
  margin-bottom: 1em !important;
}
.mobile-wrap .review {
  margin-bottom: 10px;
}
.mobile-controll {
  text-align: left;
  padding-top: 1em;
}
.mobile-wrap .filters {
  padding-left: 0;
  display: inline-block;
}
.mobile-controll .align-items-center {
  text-align: left !important;
  display: inline-block;
  width: 50%;
}
.mobile-controll p {
  text-align: left;
  display: inline-block;
}
.mobile-wrap .last-year-p {
  margin-bottom: 10px;
}
</style>
